<form [formGroup]="expenseapproverForm" (ngSubmit)="onSubmit()">
    <p-card styleClass="pt-3">
        <div class="formgrid grid">
            <div class="field col-12 lg:col-6">
                <div class="flex align-items-center">
                    <p-toggleButton 
                        inputId="internalExpense" 
                        formControlName="internalExpense" 
                        onLabel="Yes" 
                        offLabel="No"
                        [onIcon]="onIcon"
                        offIcon="pi pi-ban"
                        (onChange)="toggleInternalExpense($event)"></p-toggleButton>
                    <span class="ml-3"><b>Internal Expense</b> <span class="flex flex-nowrap">(No Client Approval Required)</span></span>
                </div>

                <div *ngIf="!expenseapproverForm.get('internalExpense')?.value" class="field mt-5">
                    <label class="field-label" for="approver">Add New Approver</label>
                    <p-autoComplete 
                        id="approver" 
                        formControlName="approver"
                        [suggestions]="approverSuggestions" 
                        (completeMethod)="searchApprover($event.query)"
                        (onSelect)="onApproverSelect($event)" 
                        placeholder="Type Approver Name"></p-autoComplete>
                </div>
            </div>

            <div *ngIf="approvers.length>0" class="field col-12 xl:col-6">
                <div>
                    <h4>Assigned Approvers</h4>
                    <p-table [value]="approvers" responsiveLayout="scroll" styleClass="approvers-table">
                        <ng-template pTemplate="body" let-approver>
                            <tr>
                                <td [ngClass]="approver.status === 'Approved' ? 'font-bold' : ''">{{ approver.assignedApproverName }}</td>
                                <td>
                                    <i [ngClass]="approver.status === 'Approved' ? 'fa-sharp fa-solid fa-user-check ui-success-80 mr-2' : 'fa-sharp fa-light fa-user-clock mr-2'"></i>
                                    <span [ngClass]="approver.status === 'Approved' ? 'ui-success-80' : 'font-italic'">
                                        {{ approver.status === 'Approved' ? approver.status : "Waiting"}}</span>
                                    
                                </td>
                                <td>
                                    <rc-generic-button 
                                        label="Delete"
                                        iconImg="trash"
                                        iconColor="red-light"
                                        [isIconOnly]="true"
                                        (click)="deleteApprover(approver)" />
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </p-card>
    <p-card>
        <p-button [outlined]="true" severity="secondary" label="Previous" (onClick)="prevCallback.emit()" />
        <p-button type="submit" label="Next" severity="secondary" />
    </p-card>
</form>
